
module.exports = (s) => {
  const config = {
    advertiser_ids: {
      label: '广告账号',
      type: 'select',
      options: [],
      value: [],
      props: {
        style: {
          width: '300px',
        },
        multiple: true,
        collapseTags: true,
        filterable: true,
      },
      on: {
        change: (val) => {
          if (val.length) {
            s.getProjectSelector();
            s.getAdSelector();
          } else {
            s.table_filter.project_ids.value = [];
            s.table_filter.project_ids.options = [];
            s.table_filter.promotion_ids.value = [];
            s.table_filter.promotion_ids.options = [];
          }
        },
      },
    },
    project_ids: {
      label: '项目',
      type: 'select',
      options: [],
      value: [],
      props: {
        multiple: true,
        collapseTags: true,
      },
    },
    promotion_ids: {
      label: '广告',
      type: 'select',
      options: [],
      value: [],
      props: {
        multiple: true,
        collapseTags: true,
      },
    },
    time_granularity: {
      label: '时间粒度',
      type: 'select',
      options: [
        {
          label: '月',
          value: 'STAT_TIME_GRANULARITY_MONTHLY',
        },
        {
          label: '周',
          value: 'STAT_TIME_GRANULARITY_WEEKLY',
        },
        {
          label: '天',
          value: 'STAT_TIME_GRANULARITY_DAILY',
        },
        {
          label: '时',
          value: 'STAT_TIME_GRANULARITY_HOURLY',
        },
      ],
      rules: {
        required: true, message: '请选择时间粒度', trigger: ['change'],
      },
      on: {
        change: (val) => {
          switch (val) {
            case 'STAT_TIME_GRANULARITY_MONTHLY':
              config.date.props.type = 'monthrange';
              config.date.props.format = 'yyyy-MM';
              config.date.value = [];
              break;
            case 'STAT_TIME_GRANULARITY_WEEKLY':
            case 'STAT_TIME_GRANULARITY_DAILY':
              config.date.props.type = 'daterange';
              config.date.props.format = 'yyyy-MM-dd';
              config.date.props.rangeSeparator = '至';
              config.date.props.startPlaceholder = '开始时间';
              config.date.props.endPlaceholder = '结束时间';
              config.date.value = [];
              break;
            case 'STAT_TIME_GRANULARITY_HOURLY':
              config.date.props.type = 'datetimerange';
              config.date.props.format = 'yyyy-MM-dd HH';
              config.date.props.rangeSeparator = '至';
              config.date.props.startPlaceholder = '开始时间';
              config.date.props.endPlaceholder = '结束时间';
              config.date.value = '';
              break;
            default:
              break;
          }
        },
      },
      value: 'STAT_TIME_GRANULARITY_DAILY',
    },
    date: {
      label: '',
      type: 'date-picker',
      value: '',
      rules: {
        required: true, message: '请选择时间', trigger: ['change'],
      },
      props: {
        type: 'daterange',
        valueFormat: 'yyyy-MM-dd HH:mm:ss',
        rangeSeparator: '至',
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
      },
    },
  };

  return config;
};
